$(document).ready(function () {

    $(".loadmore_kiosque").on("click", function (e) {
        e.preventDefault();
        load_more(false);
    });

    $(".cat_kiosque").on("click", function (e) {
        e.preventDefault();
        if(!$(this).hasClass('active')){  
            load_more($(this));       
            $(".cat_kiosque.active").removeClass("active");
            $(this).addClass("active");
        }
    });

    //------------------------------------------------------------------------------------
    // FONCTIONS
    //------------------------------------------------------------------------------------

    function load_more(change_cat) {
        var nb_post_to_display  = false;
        var nb_post_displayed   = 0; 
        var exclude_post        = false;                 
        var filtre_cat          = false; 
        var add_banner          = false; 
        if(change_cat) {

            nb_post_to_display  = change_cat.data("nb-post-to-display");
            filtre_cat          = change_cat.data('tslug'); 
            exclude_post        = change_cat.data('firsthebdo');
            add_banner          = true;
        } else {            
            nb_post_to_display  = $(".loadmore_kiosque").data("nb-post-to-display");
            nb_post_displayed   = $(".loadmore_kiosque").data("nb-post-displayed");
            exclude_post        = $(".loadmore_kiosque").data("ex-post");                
            filtre_cat          = $(".loadmore_kiosque").data("tax");
        }
       
        $.ajax({
            url: wami_js.ajaxurl,
            data: {
                action: "wami_loadmore_and_filtre_kiosque",
                nb_post_to_display: nb_post_to_display,
                exclude_post: exclude_post,
                filtre_cat: filtre_cat,
                add_banner: add_banner
            },
            success: function (data) {
                var obj = jQuery.parseJSON(data);             
                if(change_cat)  {
                    if(filtre_cat=='hebdo') $('.js-hebdo-only').show();
                    else $('.js-hebdo-only').hide();
                    $(".js-append-content").html(obj.content);
                    $(".loadmore_kiosque").data("tax", filtre_cat);
                } else {
                    $(".js-append-content").append(obj.content); 
                }         
                if(obj.more_post) {                    
                    $(".loadmore_kiosque").data("nb-post-displayed", nb_post_displayed);
                    $(".loadmore_kiosque").data("ex-post", obj.post_to_exclude);
                }
                else {
                    $(".loadmore_kiosque").remove();
                }
                
            },
            error: function (errorThrown) {
                console.log("erreur de chargement");
            },
        });
        
    }

});
